import styled from 'styled-components';

export const MobilePreviewContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;

  h2 {
    text-align: center;
    margin-bottom: 30px;
    color: #333;
    font-size: 1.8rem;
  }
`;

export const ModeSelector = styled.div`
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-bottom: 20px;

  button {
    padding: 10px 20px;
    border: 2px solid #ddd;
    background: white;
    border-radius: 25px;
    cursor: pointer;
    font-weight: 600;
    transition: all 0.3s ease;

    &:hover {
      border-color: #007bff;
      color: #007bff;
    }

    &.active {
      background: #007bff;
      color: white;
      border-color: #007bff;
    }
  }
`;

export const DeviceFrame = styled.div`
  max-width: 375px;
  margin: 0 auto;
  background: #000;
  border-radius: 25px;
  padding: 20px 15px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.3);
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: 8px;
    left: 50%;
    transform: translateX(-50%);
    width: 60px;
    height: 4px;
    background: #333;
    border-radius: 2px;
  }
`;

export const PreviewMode = styled.div`
  color: white;
  text-align: center;
  font-size: 12px;
  margin-bottom: 15px;
  opacity: 0.8;
`;

interface CourseGridProps {
  mode: 'poster' | 'cover' | 'both';
}

export const CourseGrid = styled.div<CourseGridProps>`
  display: grid;
  gap: 12px;
  height: 600px;
  overflow-y: auto;
  padding-right: 5px;

  /* Scrollbar customizada */
  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-track {
    background: #333;
    border-radius: 2px;
  }

  &::-webkit-scrollbar-thumb {
    background: #666;
    border-radius: 2px;
  }

  /* Grid layouts baseados no modo */
  ${props => {
    switch (props.mode) {
      case 'poster':
        return `
          grid-template-columns: repeat(2, 1fr);
        `;
      case 'cover':
        return `
          grid-template-columns: 1fr;
        `;
      case 'both':
        return `
          grid-template-columns: 1fr;
        `;
      default:
        return `
          grid-template-columns: repeat(2, 1fr);
        `;
    }
  }}
`;

export const CourseCard = styled.div`
  background: #1a1a1a;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;

  &:hover {
    transform: scale(1.05);
    box-shadow: 0 8px 25px rgba(255,255,255,0.1);
  }

  &.selected {
    border: 2px solid #ff6b6b;
    transform: scale(1.02);
  }
`;

export const PosterImage = styled.img`
  width: 100%;
  aspect-ratio: 2/3;
  object-fit: cover;
  display: block;
  border-radius: 4px;
`;

export const CoverImage = styled.img`
  width: 100%;
  aspect-ratio: 16/9;
  object-fit: cover;
  display: block;
  border-radius: 4px;
`;

export const CourseInfo = styled.div`
  padding: 12px;
`;

export const CourseTitle = styled.h3`
  color: white;
  font-size: 14px;
  margin: 0 0 8px 0;
  font-weight: 600;
  line-height: 1.3;
  
  /* Limitar a 2 linhas */
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const CourseDescription = styled.p`
  color: #ccc;
  font-size: 12px;
  margin: 0;
  line-height: 1.4;
  
  /* Limitar a 3 linhas */
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

/* Responsive adjustments */
export const ResponsiveContainer = styled.div`
  @media (max-width: 768px) {
    ${DeviceFrame} {
      max-width: 100%;
      margin: 10px;
      border-radius: 15px;
      padding: 15px 10px;
    }

    ${CourseGrid} {
      height: 500px;
      gap: 8px;
    }

    ${CourseTitle} {
      font-size: 13px;
    }

    ${CourseDescription} {
      font-size: 11px;
    }
  }

  @media (max-width: 480px) {
    ${MobilePreviewContainer} {
      padding: 10px;
    }

    ${ModeSelector} {
      flex-direction: column;
      gap: 8px;

      button {
        padding: 8px 16px;
        font-size: 14px;
      }
    }
  }
`;
